import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { AsnDisplay, SubHeader, ToolsListView } from '../../components';
import {
  AGGREGATES,
  RESOURCE_TYPE,
  USER_OPERATIONS,
  TOOLS,
  CHASSIS_COLUMN,
  AGGREGATE_SUBCOLUMN,
  CHASSIS_SUBCOLUMN,
  JLR_PLANT,
  APPLICATION_VARIANTS,
} from '../../constants';
import styles from './LandingPage.module.css';
import sparqplug from '../../images/sparqplug.png';
import time from '../../images/time.svg';
import asnReport from '../../images/report_icon.png';
import {
  debugLog,
  getAggregatePlanUrl,
  getAggregateUrl,
  getAggregateLineUpUrl,
  getEmergencyAgSNUrl,
  getAggregateDispatchUrl,
  getAggregateAvailabilityUrl,
  getAgSNOverviewUrl
} from '../../utils/utils';
import { getLastAsnGeneratedDateForPlantAndLine } from '../../apis/calls';

import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';
import withAllowedOperationsProvider, {
  useAllowedOperationsContext,
} from '../../hocs/withAllowedOperationsProvider/withAllowedOperationsProvider';
import config from '../../config/config';
import { ListView } from '../../components';

const LandingPage = () => {
  const {
    PRODUCTION_MASTER_DATA_UI_URL,
    APPLICATION_VARIANT,
    SPAR_Q_PLUG_BASE_URL,
  } = config;
  const history = useHistory();
  const [plant] = usePlantAndLinesStore().plantState;
  const [line] = usePlantAndLinesStore().lineState;
  const { aggregatesWithAccessToDispatch } = usePlantAndLinesStore();
  const [lineOptions] = usePlantAndLinesStore().lineOptions;
  const [isAsnDisplayOpen, setIsAsnDisplayOpen] = useState(false);
  const [endDate, setEndDate] = useState(null);

  const [selectedColumnsQueue, setSelectedColumsQueue] = useState([]);
  const [columnsRoot, setColumnsRoot] = useState(null);

  const openAsnDisplay = () => setIsAsnDisplayOpen(true);
  const closeAsnDisplay = () => setIsAsnDisplayOpen(false);

  const isLucknowProlifePlant = plant?.label === 'Lucknow-Prolife'
  const pathName = isLucknowProlifePlant ? '/engine': '/chassis'

  const allowedOperations = useAllowedOperationsContext()
    ?.allowedOperationsWithValue;

  async function loadEndDateForPlantAndLine(plant, line) {
    try {
      const lastAsnGeneratedDate = await getLastAsnGeneratedDateForPlantAndLine(
        plant.value,
        line.value,
      );
      setEndDate(lastAsnGeneratedDate);
    } catch (error) {
      debugLog('failed to get lastAsnGeneratedDate in landing page: ', error);
      setEndDate(null);
    }
  }

  const getToolOptions = () => {
    if (plant.label==="Lucknow-Prolife") {
      return[
        {
        label: TOOLS.ASN_OVERVIEW,
        authOperation: USER_OPERATIONS.GET_ASN_OVERVIEW,
        action: () => {
          history.push('/asn-live');
        },
      },
      {
        label: TOOLS.MANUFACTURING_INSIGHTS,
        authOperation: USER_OPERATIONS.GET_MANUFACTURING_INSIGHTS,
        image: (
          <img src={sparqplug} className={styles.sparqplug} alt="SparQPlug" />
        ),
        action: () => {
          if (SPAR_Q_PLUG_BASE_URL)
            window.open(SPAR_Q_PLUG_BASE_URL, '_target');
        },
      },
      {
        label: TOOLS.MASTER_DATA_MANAGEMENT,
        authOperation: USER_OPERATIONS.GET_MASTER_DATA,
        action: () => {
          window.open(PRODUCTION_MASTER_DATA_UI_URL, '_target');
        },
      },
      ]
    } else if (APPLICATION_VARIANT === APPLICATION_VARIANTS.MES4_EV){
      return[
        {
          label: TOOLS.PRODUCTION_REVIEW,
          authOperation: USER_OPERATIONS.GET_PRODUCTION_REVIEW,
          action: () => {
            history.push('/production-review');
          },
        },
        {
          label: TOOLS.ASN_OVERVIEW_REPORT,
          authOperation: USER_OPERATIONS.GET_ASN_OVERVIEW,
          image: (
            <img
              src={asnReport}
              className={styles.sparqplug}
              alt="ASN_REPORT"
            />
          ),
          action: () => {
            history.push('/asn-overview-report');
          },
        },
        {
          label: TOOLS.MASTER_DATA_MANAGEMENT,
          authOperation: USER_OPERATIONS.GET_MASTER_DATA,
          action: () => {
            window.open(PRODUCTION_MASTER_DATA_UI_URL, '_target');
          },
        },
      ]
    }
    else {
      return [
        {
          label: TOOLS.ASN_OVERVIEW,
          authOperation: USER_OPERATIONS.GET_ASN_OVERVIEW,
          action: () => {
            history.push('/asn-live');
          },
        },
        {
          label: TOOLS.DROPPING_UPDATE,
          authOperation: USER_OPERATIONS.GET_DROPPING_UPDATE,
          action: () => {
            history.push('/operator');
          },
        },
        {
          label: TOOLS.MANUFACTURING_INSIGHTS,
          authOperation: USER_OPERATIONS.GET_MANUFACTURING_INSIGHTS,
          image: (
            <img src={sparqplug} className={styles.sparqplug} alt="SparQPlug" />
          ),
          action: () => {
            if (SPAR_Q_PLUG_BASE_URL)
              window.open(SPAR_Q_PLUG_BASE_URL, '_target');
          },
        },
        {
          label: TOOLS.MASTER_DATA_MANAGEMENT,
          authOperation: USER_OPERATIONS.GET_MASTER_DATA,
          action: () => {
            window.open(PRODUCTION_MASTER_DATA_UI_URL, '_target');
          },
        },
        {
          label: TOOLS.SHIFT_CONFIGURATOR,
          authOperation: USER_OPERATIONS.GET_MASTER_SHIFT_CONFIGURATOR,
          image: (
            <div
              style={{
                backgroundColor:
                  plant.label === JLR_PLANT ? '#26662E' : '#2462ac',
                borderRadius: '100%',
                height: '32px',
                width: '32px',
              }}
            >
              <img src={time} className={styles.sparqplug} alt="time" />
            </div>
          ),
          action: () => {
            history.push('/shift-configurator');
          },
        },
        ...(plant.label === 'Pantnagar'
          ? [
            {
              label: TOOLS.ENGINE_CONFIRMATION_UPDATE,
              authOperation: USER_OPERATIONS.GET_DROPPING_UPDATE,
              action: () => {
                history.push('/Engine-Confirmation');
              },
            },
            {
              label: TOOLS.PBS_DROPPING_CONFIRMATION,
              authOperation: USER_OPERATIONS.UPDATE_CHASSIS_PLAN_ASN,
              action: () => {
                history.push('/pbs-dropping-confirmation');
              },
            },
          ]
          : []
        ),
        {
          label: TOOLS.EVR_CONFIGURATOR,
          authOperation: USER_OPERATIONS.GET_ALL_EVR,
          action: () => {
            history.push('/evr-number-configurator');
          },
        },
      ];
    };
  };

  const toolOptions = getToolOptions();

  const handleSelection = selection =>
    setSelectedColumsQueue(prev => {
      if (prev.length) {
        const lastSelection = prev[prev.length - 1];
        if (lastSelection === selection) return prev;
        while (prev.length) {
          const existingTopLevel = prev[prev.length - 1].level;
          if (existingTopLevel >= selection.level) prev.pop();
          else break;
        }
      }
      prev.push(selection);
      return [...prev];
    });

  const getArrayOfOptionSetsToRender = queue =>
    queue.map(item => item.next).filter(item => item);

  const getNextLaneForAggregate = aggregate => [
    {
      value: AGGREGATE_SUBCOLUMN.PLAN,
      label: AGGREGATE_SUBCOLUMN.PLAN,
      customLabel: styles.optionMenuLabel,
      level: 2,
      next: null,
      action: () => {
        history.push(getAggregatePlanUrl(aggregate));
      },
      isDisplayable: true,
    },
    {
      value: AGGREGATE_SUBCOLUMN.LINE_UP,
      label: AGGREGATE_SUBCOLUMN.LINE_UP,
      level: 2,
      next: null,
      action: () => {
        history.push(getAggregateLineUpUrl(aggregate));
      },
      isDisplayable: true,
    },
    {
      value: AGGREGATE_SUBCOLUMN.AVAILABILITY,
      label: AGGREGATE_SUBCOLUMN.AVAILABILITY,
      level: 2,
      customLabel: styles.optionMenuLabel,
      next: null,
      action: () => {
        history.push(getAggregateAvailabilityUrl(aggregate));
      },
      isDisplayable: true,
    },
    {
      value: AGGREGATE_SUBCOLUMN.DISPATCH,
      label: AGGREGATE_SUBCOLUMN.DISPATCH,
      level: 2,
      customLabel: styles.optionMenuLabel,
      next: null,
      action: () => {
        history.push(getAggregateDispatchUrl(aggregate));

      },
      isDisplayable: true,
    },
    {
      value: AGGREGATE_SUBCOLUMN.EMERGENCY_AGSN,
      label: AGGREGATE_SUBCOLUMN.EMERGENCY_AGSN,
      level: 2,
      next: null,
      action: () => {
        history.push(getEmergencyAgSNUrl(aggregate));
      },
      isDisplayable: true,
    },
    {
      value: AGGREGATE_SUBCOLUMN.AGSN_OVERVIEW,
      label: AGGREGATE_SUBCOLUMN.AGSN_OVERVIEW,
      level: 2,
      next: null,
      action: () => {
        history.push({
          pathname: getAgSNOverviewUrl(aggregate),
          state: { aggregate }
        });
      },
      isDisplayable: true,
    },
  ];

  const getNextLaneForMaterial = aggregate => [
    {
      value: AGGREGATE_SUBCOLUMN.DISPATCH,
      label: AGGREGATE_SUBCOLUMN.DISPATCH,
      level: 2,
      customLabel: styles.optionMenuLabel,
      next: null,
      action: () => {
        history.push(getAggregateUrl(aggregate));
      },
      isDisplayable: true,
    },
  ];

  const getNextLaneForChassis = () => [
    {
      value: 'Plan',
      label: CHASSIS_SUBCOLUMN.PLAN,
      level: 2,
      customLabel: styles.optionMenuLabel,
      next: null,
      action: () => {
        history.push('/planning');
      },
      isDisplayable: true,
    },
    {
      value: 'Line Up',
      label: CHASSIS_SUBCOLUMN.LINE_UP,
      level: 2,
      customLabel: styles.optionMenuLabel,
      next: null,
      action: () => {
        history.push(pathName);
      },
      isDisplayable: true,
    },
    {
      value: 'View Asn',
      label: CHASSIS_SUBCOLUMN.VIEW_ASN,
      level: 2,
      customLabel: styles.optionMenuLabel,
      next: null,
      action: openAsnDisplay,
      isDisplayable: true,
    },
    {
      value: 'Month Plan',
      label: CHASSIS_SUBCOLUMN.MONTH_PLAN,
      level: 2,
      customLabel: styles.optionMenuLabel,
      next: null,
      action: () => {
        history.push('/monthly-plan');
      },
      isDisplayable: true,
    },
  ];

  const isShopTypeTabDisplayable = (shopType, allowedOperationsForUser) => {
    return shopType === AGGREGATES.MATERIAL
      ? allowedOperationsForUser
        .map(allowedOperation => allowedOperation.operation)
        .includes(USER_OPERATIONS.GET_SCM_MATERIAL_TAB)
      : allowedOperationsForUser
        .map(allowedOperation => allowedOperation.operation)
        ?.includes(USER_OPERATIONS.GET_DISPLAYABLE_SHOP_TYPES) &&
      allowedOperationsForUser
        .filter(
          allowedOperation =>
            allowedOperation.operation ===
            USER_OPERATIONS.GET_DISPLAYABLE_SHOP_TYPES,
        )
        .some(
          allowedOperation =>
            (allowedOperation.value.includes(shopType) &&
              (allowedOperation.value.includes(`plant:${plant.value}`) ||
                allowedOperation.value.includes(`plant:*`))) ||
            (allowedOperation.value.includes('shop_type:*') &&
              (allowedOperation.value.includes(`plant:${plant.value}`) ||
                allowedOperation.value.includes(`plant:*`))) ||
            allowedOperation.value === `org:tml:resource:*` ||
            allowedOperation.value === `org:tml:*` ||
            allowedOperation.value === `org:*` ||
            allowedOperation.value === '*',
        );
  };

  const getChassisColumn = () =>
    Object.values(CHASSIS_COLUMN).map(chassis => ({
      label:
        APPLICATION_VARIANT === APPLICATION_VARIANTS.MES4_EV
        ? APPLICATION_VARIANTS.MES4_EV
        : plant?.label === 'Pantnagar'
          ? 'TCF'
          : plant?.label === 'Lucknow-Prolife'
            ? 'Engine'
            : chassis,
      next: getNextLaneForChassis(chassis),
      level: 1,
      customLabel: styles.optionMenuLabel,
      action: null,
      isDisplayable: isShopTypeTabDisplayable(chassis, allowedOperations),
    }));

  const getAggregateColumns = () => {
    const columns = [];
      const hiddenAggregates=[
        AGGREGATES.FRAME,
        AGGREGATES.CYLINDER_HEAD,
        AGGREGATES.CAB,
        // Hide Lucknow-Prolife specific aggregates
        AGGREGATES.CAMSHAFT,
        AGGREGATES.CYLINDER_BLOCK,
        AGGREGATES.CRANKSHAFT
      ]

      const allowedAggregatesLucknowProlife = [
        AGGREGATES.CAMSHAFT,
        AGGREGATES.CYLINDER_HEAD,
        AGGREGATES.CYLINDER_BLOCK,
        AGGREGATES.CRANKSHAFT
      ]
    
      if (APPLICATION_VARIANT === APPLICATION_VARIANTS.MES4_EV) {
        columns.push({
          label: AGGREGATES.BIW,
          next: getNextLaneForAggregate(AGGREGATES.BIW),
          level: 1,
          customLabel: styles.optionMenuLabel,
          action: null,
          isDisplayable: isShopTypeTabDisplayable(AGGREGATES.BIW, allowedOperations),
        });
      } else {
        columns.push(
          ...Object.values(AGGREGATES).filter(aggregate=>{
            if(plant.label==="Pantnagar"){
              return !hiddenAggregates.includes(aggregate);
            }
            if(plant.label==="Lucknow-Prolife") {
              return allowedAggregatesLucknowProlife.includes(aggregate)
            }
            return !allowedAggregatesLucknowProlife.includes(aggregate);
          }).map(aggregate => ({
            label: aggregate,
            next: getNextLaneForAggregate(aggregate),
            level: 1,
            customLabel: styles.optionMenuLabel,
            action: null,
            isDisplayable: isShopTypeTabDisplayable(aggregate, allowedOperations),
          }))
        );
      }
    
      return columns;
    };
    
    
  useEffect(() => {
    if (plant?.value && line?.value) loadEndDateForPlantAndLine(plant, line);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [line, plant]);

  useEffect(() => {
    const aggregateColumns = getAggregateColumns();
    const chassisColumns = getChassisColumn();
    setColumnsRoot([...chassisColumns, ...aggregateColumns]);
    setSelectedColumsQueue([]);
    return () => {
      setSelectedColumsQueue([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aggregatesWithAccessToDispatch, allowedOperations, plant.value]);

  return (
    <div className={styles.mainBody}>
      <>
        <AsnDisplay
          enableLineSelection
          open={isAsnDisplayOpen}
          handleClose={closeAsnDisplay}
          endDate={endDate}
          plant={plant.value}
          line={line.value}
          lineName={line.label}
          lineOptions={lineOptions}
        />
      </>

      <div className={styles.container}>
        <div style={{ marginBottom: '1em' }}>
          <SubHeader title="PPC" />
        </div>
        <div className={styles.columnsContainer}>
          <div
            style={{ height: '100%' }}
            className={styles.columnsContainerLeft}
          >
            <ListView
              title="Select"
              listItems={columnsRoot}
              handleSelection={handleSelection}
            />
            {getArrayOfOptionSetsToRender(selectedColumnsQueue).map(
              (listItems, index) => (
                <ListView
                  key={`${selectedColumnsQueue[0].label}-${listItems[0]?.level}`}
                  title={index === 1 ? 'Action' : 'Select'}
                  listItems={listItems}
                  handleSelection={handleSelection}
                />
              ),
            )}
          </div>
          <div>
            <ToolsListView
              listItems={toolOptions}
              handleSelection={handleSelection}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default withAllowedOperationsProvider(
  LandingPage,
  false,
  RESOURCE_TYPE.CHASSIS,
  RESOURCE_TYPE.PLANT,
  RESOURCE_TYPE.DISPLAYABLE_SHOP,
  RESOURCE_TYPE.DISPLAYABLE_SCM_MATERIAL_TAB,
);
